'use client';

import { useMemo } from 'react';

import { useTriviaBg } from '../hooks/useBgTriviaResult';

import triviaBgNoText from '@/assets/trivia-bg--no-text-desk.jpg';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import type { ResponseDashTriviaInit } from '@/types/dashboard';

interface TriviaContentLeftProps {
  triviaInit?: ResponseDashTriviaInit;
  isWinner: boolean;
  isTriviaClosed?: boolean;
}

export const TriviaContentLeft = ({
  triviaInit,
  isWinner,
  isTriviaClosed,
}: TriviaContentLeftProps) => {
  const { isMobile } = useIsDesktop();

  const bgResult = useTriviaBg(isMobile, isWinner ? 'winner' : 'loser');

  const shouldShowResult = useMemo(() => {
    return (
      triviaInit?.yaParticipa ||
      (Boolean(triviaInit?.trv) &&
        Boolean(triviaInit?.resultadoParticipacion) &&
        triviaInit?.trv?.nombre ===
          triviaInit?.resultadoParticipacion?.nombreTriviaDesencadenante) ||
      (!triviaInit?.hayTriviaActiva &&
        Boolean(triviaInit?.trvAnt) &&
        Boolean(triviaInit?.resultadoParticipacion) &&
        triviaInit?.trvAnt?.nombre ===
          triviaInit?.resultadoParticipacion?.nombreTriviaDesencadenante)
    );
  }, [triviaInit]);

  const anyActiveTrivia = useMemo(() => {
    return triviaInit?.hayTriviaActiva || triviaInit?.hayTriviaPendiente;
  }, [triviaInit]);

  if (isTriviaClosed || !anyActiveTrivia) {
    return (
      <div className="relative h-full">
        <img
          alt="Trivia"
          className="rounded-l-lg w-full h-full object-cover lg:object-left"
          decoding="async"
          loading="lazy"
          src={triviaBgNoText}
        />
      </div>
    );
  }

  if (!shouldShowResult) {
    return (
      <div className="flex flex-col relative h-full">
        <div className="rounded-l-lg w-full h-full bg-gray-200 overflow-hidden">
          <img
            alt="Trivia Gran DT"
            className="rounded-l-lg w-full h-full object-cover lg:object-left"
            loading="lazy"
            src={triviaBgNoText}
          />
        </div>
        <div className="absolute flex items-center w-full justify-center h-full">
          <div className="tracking-[2px] text-white font-semibold font-bebas text-[42px] leading-10">
            <p className="leading-12 text-[36px] -top-1 relative left-2">
              ¡Participá
              <br />
              por medallas
              <br />
              todas las fechas!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative h-full">
      <div className="rounded-l-lg w-full h-full bg-gray-200 overflow-hidden">
        {bgResult && (
          <img
            alt="Trivia Gran DT"
            className="rounded-l-lg w-full h-full object-cover lg:object-left"
            loading="lazy"
            src={bgResult}
          />
        )}
      </div>
      <div className="absolute flex items-center w-full justify-center h-full">
        <div className="tracking-[2px] text-white font-semibold font-bebas text-[42px] leading-10">
          {isWinner ? (
            <>
              {triviaInit?.msjGanador ? (
                <span>{triviaInit?.msjGanador}</span>
              ) : (
                <p>
                  <span className="tracking-wide">¡Felicitaciones!</span>
                  <br />
                  Ganaste una
                  <br /> medalla
                </p>
              )}
            </>
          ) : (
            <p className="leading-12 text-[36px] -top-1 relative left-2">
              Lamentablemente,
              <br />
              no ganaste
              <br />
              una medalla
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
